export default "__VITE_ASSET__BX78GdgE__"